export const create = {
  form: {
    price: 'Price',
    quantity: 'Quantity',
    submit: 'Submit',
    name: 'Name',
    requirePrice: 'Please input price',
    requireQuantity: 'Please input quantity',
    priceUnit: '¥',
    quantityUnit: 'gram',
    invalidLetters: 'Only letters are allowed.',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'Add New Detergent history',
    back: 'Back',
  },
}
